import { NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { EffectsModule } from '@ngrx/effects';
import { KycEffects } from '../../ngrx/KYC/kyc.effects';

@NgModule({
  imports: [CoreModule, EffectsModule.forFeature([KycEffects])],
})
export class HomeModule {}
